import { render, staticRenderFns } from "./search-table.vue?vue&type=template&id=818fe508"
import script from "./search-table.vue?vue&type=script&lang=js"
export * from "./search-table.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports